import { Badge } from "./feedback";
import { humanize, statusTone } from "./status";

/** A status word with a consistent colour everywhere (``data-status`` helps tests). */
export function StatusBadge({ status }: { status: string }) {
  return (
    <span data-status={status} className="contents">
      <Badge tone={statusTone(status)}>{humanize(status)}</Badge>
    </span>
  );
}
